(function(Backbone, _, $) {

  /* ------------------------------------------------------------------------
   * Miscellaneous Backbone View functions
   */
  var BackboneMisc = Backbone.View.extend({

    el: '',
    events: {
      //'click .cfg???': '_clickDetails',
      'click .cfgQuestHeaderDetailButton': '_clickDetails',
      'click .cfgVideoBoxFeature': '_clickVideo'
    },
    model: null,

    initialize: function(options) {
      this.model = new Backbone.Model({
        showImage: false,
        showVideo: false
      });

      this.listenTo(this.model, 'change', this.render);
      _.bindAll(this, '_clickDetails', '_clickVideo', 'render');
      //globally add a "toggle" method to all backbone models
      Backbone.Model.prototype.toggle = function(attr, options) {
        options = options ? _.clone(options) : {}
        return this.set(attr, !this.get(attr), options);
      }

    },

    render: function() {
      var changed = this.model.changed;
      console.log("clicked");

    },

    _clickDetails: function(event) {
      /*
      $('.cfgQuestHeaderDetailButtonFOO').click(function(event) {
      		          event.preventDefault();
      		          // $(this) =  what has been clicked
      		          var $parent = $(this).parent().parent();
      		          var $img = $parent.find('div.details');

      		          if (!$img[0]) {
      		            var p_href = $(this).attr('href');
      		            var img = '<div class="details"><img class="" src="' + p_href + '" /></div>';
      		            var $img = $(img);s
      		            $parent.append($img);
      		          } else {
      		            $img.slideUp(333, function() {d
      		              $(this).remove();
      		            });*/
      event.preventDefault();
      var $parent = $(this).parent().parent();
      var $img = $parent.find('div.cfgQuestWrapper');
      var p_href = $(this).attr('href');
      var img = '<div class="details"><img class="" src="' + p_href + '" /></div>';
      var $img = $(img);
      //$parent.append($img);
      this.$el.append($img);
      console.log($parent);
    },


    _clickVideo: function(event) {}


  });

  $(".cfgQuestWrapper").each(function() {
    var bv = new BackboneMisc({ el: $(this) });
  });

})(Backbone, _, jQuery);
